// Bayan Wear: image-saving deterrents. Public images and screenshots cannot be secured by browser code.
(function () {
  'use strict';
  var mediaSelector = 'img, picture, .protected-image, [data-bgset], [data-bw-image-protected]';
  var rawImage = /\.(?:avif|bmp|gif|ico|jpe?g|png|svg|webp)(?:$|[?#])/i;

  function elementFor(target) {
    return target && (target.nodeType === 1 ? target : target.parentElement);
  }
  function imageLink(target) {
    var el = elementFor(target);
    var link = el && el.closest('a[href]');
    return link && rawImage.test(link.getAttribute('href') || '') ? link : null;
  }
  function onImage(target) {
    var el = elementFor(target);
    if (!el || el.closest('input, textarea, select, [contenteditable="true"]')) return false;
    if (el.closest(mediaSelector) || imageLink(el)) return true;
    // Covers background photos and overlays, without disabling ordinary text menus.
    for (var node = el, depth = 0; node && node !== document.body && depth < 5; node = node.parentElement, depth++) {
      if (window.getComputedStyle(node).backgroundImage.indexOf('url(') !== -1) return true;
    }
    return false;
  }
  function blockImageMenu(event) {
    if (onImage(event.target)) event.preventDefault();
  }
  document.addEventListener('contextmenu', blockImageMenu, true);
  document.addEventListener('dragstart', blockImageMenu, true);
  document.addEventListener('selectstart', blockImageMenu, true);
  // Only direct image-file links are blocked; product and collection links remain usable.
  ['click', 'auxclick'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!imageLink(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  });

  function protect(root) {
    if (!root || !root.querySelectorAll) return;
    var images = Array.from(root.querySelectorAll('img, picture, .protected-image, [data-bgset], [style*="background-image"]'));
    if (root.matches && root.matches('img, picture, .protected-image, [data-bgset], [style*="background-image"]')) images.push(root);
    images.forEach(function (el) {
      el.setAttribute('data-bw-image-protected', '');
      if (el.tagName === 'IMG') el.setAttribute('draggable', 'false');
      var link = el.closest('a');
      if (link) {
        link.setAttribute('data-bw-image-protected', '');
        link.setAttribute('draggable', 'false');
      }
    });
  }
  function initImageProtection() {
    protect(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) protect(node); });
      });
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initImageProtection, {once: true});
  else initImageProtection();

  function syncBayanMobileNav(){
    var source = document.querySelector('#t4s-nav-ul');
    var mobile = document.querySelector('#menu-mb__ul');
    if (!source || !mobile) return;

    var links = source.querySelectorAll(':scope > li > a');
    if (!links.length) return;

    var frag = document.createDocumentFragment();
    links.forEach(function(link){
      var li = document.createElement('li');
      li.className = 't4s-menu-item t4s-item-level-0';
      var a = document.createElement('a');
      a.href = link.getAttribute('href') || '/';
      a.textContent = (link.textContent || '').trim();
      if (link.closest('li') && link.closest('li').classList.contains('is--nav__active')) {
        li.classList.add('is--current');
      }
      li.appendChild(a);
      frag.appendChild(li);
    });

    mobile.innerHTML = '';
    mobile.appendChild(frag);
  }

  function initBayanCleanup(){
    syncBayanMobileNav();
    window.setTimeout(syncBayanMobileNav, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBayanCleanup);
  } else {
    initBayanCleanup();
  }
  document.addEventListener('shopify:section:load', initBayanCleanup);

})();
